module.exports = __webpack_public_path__ + "static/media/notice-1.6bef1e9d.jpg";